import { map } from 'lodash-es'
import { useState } from 'react'

import { Checkbox } from '@/components/ui'
import { Currency, Vouchers } from '../../../common/models'
import { IColumn, Table } from '../../../core/components/Table'
import { formatDateTime } from '../../../core/constants/times'

export interface VoucherHistoryTableProps {
  isCheck?: string[]
  setIsCheck?: (check: string[]) => void
  vouchers: Vouchers[]
  setVouchers: (v: Vouchers[]) => void
  page: number
  setPage: (p: number) => void
  size: number
  setSize: (s: number) => void
  sortBy?: string
  setSortBy: (s?: string) => void
  sortDirection?: 'ASC' | 'DESC'
  setSortDirection: (s?: 'ASC' | 'DESC') => void
  totalElements: number
  setTotalElemenets: (t: number) => void
  isOneToOne: boolean
  dateFilters?: JSX.Element
  currency?: Currency | null
  handleSearchParams?: (col: IColumn, query: string | null) => void
}

export const VoucherHistoryTable = (
  props: VoucherHistoryTableProps,
): JSX.Element => {
  const {
    isCheck,
    setIsCheck,
    vouchers,
    size,
    page,
    setPage,
    setSize,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    totalElements,
    dateFilters,
    currency,
    handleSearchParams,
  } = props

  const [isCheckAll, setIsCheckAll] = useState(false)

  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll)
    setIsCheck?.(vouchers.map((voucher) => voucher.id))
    if (isCheckAll) {
      setIsCheck?.([])
    }
  }
  const handleClick = (id: string) => {
    if (isCheck) {
      setIsCheck?.([...isCheck, id])
    } else {
      setIsCheck?.([])
    }
  }

  const handleSortBy = (sort: string) => {
    if (sort === sortBy) {
      if (sortDirection === 'DESC') {
        setSortDirection('ASC')
      } else {
        setSortDirection(undefined)
        setSortBy(undefined)
      }
    } else {
      setSortDirection('DESC')
      setSortBy(sort)
    }
  }

  const pageChange = async (newPage: number) => {
    setPage(newPage)
  }

  const columns: IColumn[] = [
    {
      title: (
        <Checkbox onCheckedChange={handleSelectAll} checked={isCheckAll} />
      ),
      accessor: '',
      render: (row) => (
        <Checkbox
          onCheckedChange={() => handleClick(row.id)}
          checked={isCheck?.includes(row.id)}
        />
      ),

      width: '16px',
    },
    {
      title: 'Id',
      accessor: 'id',
      sortable: true,
      render: (row) => row.id.substring(0, 8),
    },
    {
      title: 'Voucher Name',
      accessor: 'name',
      sortable: true,
      render: (row) => row.batchLabel,
    },
    {
      title: 'Voucher Code',
      accessor: 'voucherCode',
      searchable: true,
      render: (row) => (
        <div className="flex flex-col">
          <span>{row.code}</span>
        </div>
      ),
    },
    {
      title: 'Discount',
      accessor: 'discount',
      render: (row) =>
        row.voucherDiscountType === 'AMOUNT'
          ? `${row.voucherDiscountAmount} ${currency?.symbol}`
          : `${row.voucherDiscountAmount}%`,
    },
    {
      title: 'Type',
      accessor: 'type',
    },
    {
      title: 'Tickets',
      accessor: 'tickets',
      render: (row) => (
        <div className="flex flex-col">
          <div className="flex flex-col">
            {map(row.tickets, (ticket, index) => {
              return (
                <div key={`${ticket}-${index}`} className="flex gap-2">
                  <span>ticket</span>
                </div>
              )
            })}
          </div>
        </div>
      ),
    },
    {
      title: 'Use Date',
      accessor: 'date',
      render: (row) => formatDateTime(row.date),
    },
  ]

  return (
    <>
      {dateFilters}
      <Table
        isCheck={isCheck}
        columns={columns}
        handleSortBy={handleSortBy}
        data={vouchers}
        className="text-nowrap"
        handleSearch={handleSearchParams}
      />
    </>
  )
}
